import { empreendedoresPath, siteCanonicalUrl } from '../siteDestinations'

export const empreendedoresTitle = 'IA para empreendedores | Acompanhamento individual'
export const empreendedoresDescription = 'Aprenda a usar inteligência artificial nas tarefas do seu negócio, com acompanhamento individual online. Comece com uma conversa gratuita de 30 minutos com Arthur.'

/** As mesmas respostas são exibidas na página e na ficha de busca. */
export const empreendedoresFaqItems = [
  {
    question: 'Nunca usei IA. Consigo acompanhar?',
    answer: 'Sim. O acompanhamento começa pelos primeiros passos com IA, a partir de uma tarefa do seu negócio. Conte ao Arthur o que você já faz no computador e o que gostaria de facilitar.',
  },
  {
    question: 'Não entendo de tecnologia. Serve para mim?',
    answer: 'Serve. Você traz o que sabe do seu negócio. Arthur mostra cada passo no computador, e você pratica junto com ele até fazer sozinho.',
  },
  {
    question: 'Serve para o meu tipo de negócio?',
    answer: 'O acompanhamento parte das tarefas do seu negócio: comércio, escritório, consultório ou serviço. Na primeira conversa, você conta como trabalha e Arthur mostra onde a IA entra primeiro.',
  },
  {
    question: 'Quanto tempo até eu usar sozinho?',
    answer: 'O acompanhamento tem 9 horas, de 1 a 2 horas por semana. O objetivo é que, ao fim dessas horas, você use IA sozinho nas tarefas do seu negócio.',
  },
  {
    question: 'O acompanhamento é online?',
    answer: 'Sim. O acompanhamento é individual e online. Você participa pelo seu computador, com Arthur acompanhando sua prática e suas dúvidas.',
  },
  {
    question: 'O que preciso para participar?',
    answer: 'Você precisa de um computador com acesso à internet, tanto para os encontros online quanto para praticar com as ferramentas de inteligência artificial.',
  },
  {
    question: 'Quais ferramentas de inteligência artificial posso aprender?',
    answer: 'Podemos trabalhar com qualquer ferramenta de inteligência artificial que você queira aprender a usar. A escolha acompanha o que o seu negócio precisa.',
  },
  {
    question: 'Como começo e quanto custa?',
    answer: 'O primeiro passo é marcar a primeira conversa, gratuita: 30 minutos com Arthur. O acompanhamento tem 9 horas pagas, além da conversa gratuita, de 1 a 2 horas por semana. O valor é combinado na conversa.',
  },
  {
    question: 'Vou poder tirar dúvidas?',
    answer: 'Sim. Os encontros são individuais, com atenção às suas dúvidas e ao que você quer aprender. Você pode perguntar, praticar com Arthur e repetir os passos no seu ritmo. Arthur também responde dúvidas pelo WhatsApp entre os encontros.',
  },
  {
    question: 'Posso indicar para um sócio ou colega?',
    answer: 'Pode. Compartilhe o endereço desta página. A pessoa conhece a proposta e marca a própria conversa com Arthur, a partir do negócio dela.',
  },
] as const

const pageUrl = `${siteCanonicalUrl}${empreendedoresPath}`

export const empreendedoresStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${pageUrl}#webpage`,
      url: pageUrl,
      name: empreendedoresTitle,
      description: empreendedoresDescription,
      inLanguage: 'pt-BR',
      isPartOf: { '@id': `${siteCanonicalUrl}/#website` },
      about: { '@id': `${siteCanonicalUrl}/#organization` },
      primaryImageOfPage: `${siteCanonicalUrl}/assets/share/oficina-ia-1200x630.png`,
    },
    {
      '@type': 'FAQPage',
      '@id': `${pageUrl}#faq`,
      mainEntity: empreendedoresFaqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ],
} as const

export function empreendedoresStructuredDataScript(): string {
  return `<script type="application/ld+json">${JSON.stringify(empreendedoresStructuredData).replace(/</g, '\\u003c')}</script>`
}
